import { Button } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

export const CyanButton = withStyles((theme) => ({
    root: {
      color: 'white',
      backgroundColor: '#06b6d4',
      '&:hover': {
        backgroundColor: '#06b6d4e6',
      },
    },
}))(Button);